export const certifications = {
    nursery_school: {
        name: 'Agrément maternelle (PMI)'
    },
    national_education: {
        name: 'Agrément Education Nationale'
    },
    youth_sports: {
        name: 'Agrément Jeunesse et Sports'
    }
}

export function getMediasBySector(accomodation: Accomodation, sector: string): Media[] {
    return accomodation.medias.filter(media => {
        if (!media.collectionItemMetadata) return false
        if (!media.collectionItemMetadata.sectors) return false
        if (Array.isArray(media.collectionItemMetadata.sectors) === false) return false
        return media.collectionItemMetadata.sectors.includes(sector)
    })    
}

export function getDocumentsBySector(accomodation: Accomodation, sector: string): zDocument[] {
    return accomodation.documents.filter(document => {
        if (!document.collectionItemMetadata) return false
        if (!document.collectionItemMetadata.sectors) return false
        if (Array.isArray(document.collectionItemMetadata.sectors) === false) return false
        return document.collectionItemMetadata.sectors.includes(sector)
    })    
}
